import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ToggleContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <HorizontalContainer className={`${className} ${styles.toggleContainer}`} testId={testId}>
        {children}
    </HorizontalContainer>
);

export default ToggleContainer;
